import React from "react";
import { InvoiceFiles } from "../../../models/settlement.model";
import { Box, Typography } from "@mui/material";
import LoadDocumentCmp from "../../../components/thumbnail/loadDocumentCmp";

interface Props {
  invoiceFiles: InvoiceFiles[];
}

const FactorsImage = ({ invoiceFiles }: Props) => {
  return (
    <div>
      <Typography>فاکتور فروش</Typography>
      {invoiceFiles?.map((item) => (
        <Box
          sx={{
            minWidth: 200,
            maxWidth: 250,
            marginTop: "10px",
            display: "inline-block",
            paddingInline: "10px",
          }}
        >
          <LoadDocumentCmp data={item} title={true} />
        </Box>
      ))}
    </div>
  );
};

export default FactorsImage;
